import React, { createContext, useContext, useEffect, useState, useMemo } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";

const BrandContext = createContext(null);

export const BrandProvider = ({ children }) => {
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/brands").then(({ data }) => setBrands(data)).finally(() => setLoading(false));
  }, []);

  return (
    <BrandContext.Provider value={{ brands, loading }}>
      {children}
    </BrandContext.Provider>
  );
};

export const useBrands = () => useContext(BrandContext);

/**
 * Hook for the *active* brand based on the URL param /:brand.
 * Returns the brand config object or null if param missing/unknown.
 */
export const useActiveBrand = () => {
  const { brand: key } = useParams();
  const { brands } = useBrands();
  return useMemo(() => {
    if (!key) return null;
    return brands.find((b) => b.key === key) || null;
  }, [key, brands]);
};

/**
 * Apply brand theme to document root as CSS variables.
 * Returns a className to put on a wrapper.
 */
export const useApplyBrandTheme = (brand) => {
  useEffect(() => {
    if (!brand) return;
    const root = document.documentElement;
    root.style.setProperty("--brand-primary", brand.primary);
    root.style.setProperty("--brand-secondary", brand.secondary);
    root.style.setProperty("--brand-accent", brand.accent);
    root.style.setProperty("--brand-bg", brand.bg);
    root.setAttribute("data-brand", brand.key);
    return () => root.removeAttribute("data-brand");
  }, [brand]);
};
